export default __webpack_public_path__ + "static/media/microsoftSigninDarkButton.b24ba740.svg";